import { CardActivityItem } from '@/src/experiences/card-activity/components/feed/_highnote/CardActivityItem'
import { AutoPayIcon } from '@/src/assets/icons/AutoPayIcon'
import { PaymentIcon } from '@/src/assets/icons/PaymentIcon'
import { CardPaymentsE2E } from '@/src/experiences/card-payments/e2e'
import { mesaColorNames } from '@/src/common/theme'
import type { ComponentProps } from 'react'
import { SchedulePaymentsApi } from '@/src/experiences/card-payments/store/api'
import { formatCentsAsDollars } from '@/src/common/utils/general'
import { z } from 'zod/v4'
import type { CardAccountTransferScheduleAmountData } from '@acre-rewards/lib'
import { formatToTextMonth } from '@/src/common/utils/date'

export function renderPaymentScheduleAmount(
  amount: z.infer<typeof CardAccountTransferScheduleAmountData>,
) {
  switch (amount.amountType) {
    case 'min':
      return 'Minimum Payment'
    case 'statement':
      return 'Remaining Statement Balance'
    case 'total':
      return 'Current Balance'
    case 'static':
      return formatCentsAsDollars(amount.amountCents)
  }
}

export function PaymentScheduleRow({
  type,
  id,
  processDateTime,
  index,
  style,
  linkProps,
  ...props
}: (typeof SchedulePaymentsApi.endpoints)['GET /card/:cardAccountId/payments/schedules']['Types']['ResultType'][number] & {
  index: number
} & Pick<ComponentProps<typeof CardActivityItem>, 'style' | 'linkProps'>) {
  return (
    <CardActivityItem
      key={id}
      testID={`${CardPaymentsE2E.Ids.Press.ScheduledPayment}.${index}`}
      icon={type === 'recurring' ? <AutoPayIcon /> : <PaymentIcon />}
      title={type === 'recurring' ? 'Auto-pay' : 'One-time Payment'}
      status="Active"
      amount={renderPaymentScheduleAmount(props)}
      amountColor={mesaColorNames['Greyscale/500 #6E7375']}
      date={
        processDateTime
          ? { formatted: formatToTextMonth(new Date(processDateTime), {}) }
          : undefined
      }
      style={style}
      linkProps={linkProps}
    />
  )
}
